module.exports = __webpack_public_path__ + "img/Rectangle 225@2x.c3e0e385.png";